import { HighlightFeedback } from '../../../team-apis/otterdam/feedback';

export interface HighlightMetadata {
  startIndex: number;
  endIndex: number;
  objectId: number;
  text: string;
}

export class HighlightState {
  highlighted?: HighlightFeedback;
  inProgress?: HighlightMetadata;
  selected?: HighlightFeedback;
}
